<div class="content">
  <div class="container-fluid">
    <div class="row pl-0 pr-0">
      <div class="col-md-12 page-heading page-header">
        <h2>Manage LCA</h2>
        <p>Manage existing LCAs or create new LCA</p>
      </div>
      <div class="helpvedio">
        <app-help-video-overlay #helpVideoComponent></app-help-video-overlay>
      </div>

    </div>


    <div class="content-container pb-1">
      <div class="row" class="page-heading">
        <h5 class="labelText mb-2">Add / Edit LCA</h5>
      </div>
      <div class="row">
        <!-- <button class="back-button"  *ngIf="originPage" (click)="backToOriginPage()"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i>
            {{originPage }}
          </button> -->
        <button class="back-button back-btn-white-bg pl-0" *ngIf="originPage || isDuplicateLCA"
          (click)="backToOriginPage()"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i>
          Back
        </button>
      </div>
    
      <!-- Radio button -->
      <div class="col-12 mt-1 pl-3">
        <label class="control-lbl required mt-2 label-cls">What do you want to do ? </label>
        <div class="row pt-2">
          <mat-radio-group aria-label="Select an option" [(ngModel)]="eFileLCa">
            <mat-radio-button [checked]="'lcaEFile'" [value]="'lcaEFile'">E-File LCA <i class=" pi pi-exclamation-circle"
              pTooltip="You can E-File LCA through Imagility. Once Imagility is integrated with the FLAG system, all the necessary LCA information is automatically populated from the platform to the form on the FLAG portal"></i></mat-radio-button>
            <mat-radio-button [checked]="'filedLCA'" [value]="'filedLCA'">Add Filed LCA <i class="pi pi-exclamation-circle"
              pTooltip="If you have directly filed LCA (Outside Imagility) on the FLAG portal, please add filed LCA detials"></i></mat-radio-button>
            <mat-radio-button [checked]="'certifiedLCA'" [value]="'certifiedLCA'" (change)="filedLcaType = 'automatic'">Add Certified LCA <i class="pi pi-exclamation-circle"
              pTooltip="If the LCA you filed has been certified by the DOL, please update employment and add details"></i></mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <!-- Radio button -->
    </div>

    <div *ngIf="eFileLCa != 'lcaEFile'">
      <app-view-lca *ngIf="showTheViewModeSection" (enableEditSection)="editChangeHandler($event)"></app-view-lca>
      <div class="content-container pb-0" *ngIf="!showTheViewModeSection">
        <mat-card>
    
          <div class="row">
            <mat-horizontal-stepper #stepper labelPosition="bottom">
              <mat-step>
                <ng-template matStepLabel>LCA Details</ng-template>

                <!-- Radio button -->
                <div *ngIf="eFileLCa == 'filedLCA'" class="col-12 mt-1 pl-3 mb-2">
                  <label class="control-lbl required mt-2 label-cls">How do you want to add filed LCA? </label>
                  <div class="row pt-2">
                    <mat-radio-group aria-label="Select an option" [(ngModel)]="filedLcaType">
                      <mat-radio-button [checked]="'automatic'" [value]="'automatic'">Upload filed document to fetch LCA data</mat-radio-button>
                      <mat-radio-button [checked]="'manual'" [value]="'manual'">Upload details manually</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <!-- Radio button -->

                <div *ngIf="(eFileLCa == 'filedLCA' && filedLcaType === 'automatic') || eFileLCa == 'certifiedLCA'" class="row lca-upload mt-4">
                  <div class="col-12 file-upload-container">
                    <h6 class="upload-head">Upload documents and extract text quickly</h6>
                    <p>
                      <span class="sub-head">Required Documents: </span>
                      <span *ngIf="eFileLCa == 'filedLCA'" class="sub-text">Filed LCA</span>
                      <span *ngIf="eFileLCa == 'certifiedLCA'" class="sub-text">Certified LCA</span>
                    </p>
                    <p><span class="sub-head">Upload: </span><span class="sub-text">PDF, JPG, JPEG, PNG, (Size - 10 MB max)</span></p>
                    <div class="content-container">
                      <div class="upload-box">
                        <app-file-upload style="width: 100%" [configurations]="lcaDocumentFileUploadConfigurations"
                          (filesDataChange)="onFilesDataChange($event)"></app-file-upload>
                      </div>
                      <div class="preview-container">
                        <p><img class="preview-img" alt="Preview" src="../../../../assets/images/details_default.png" /></p>
                        <button type="button" class="btn btn-primary mr-3" (click)="convertUpload()"
                          [disabled]="!ocrLCAUploadedFilesData">Convert</button><i class="info-icon fa fa-info-circle"
                          pTooltip="Extract Details"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <mat-divider></mat-divider>
                <app-add-lca-new [lcaType]="eFileLCa" (enableLCAid)="lcaChangeHandler($event)"
                  [extractedLCADetails]="extractedLCADetails"></app-add-lca-new>
              </mat-step>
    
              <mat-step>
                <ng-template matStepLabel>Additional Info & Documents</ng-template>
                <mat-divider></mat-divider>
                <div>
                  <div class="pt-3 mb-4">
                    <h6 class="labelText"><b> Workforce Notification Details</b></h6>
                  </div>
                  <!-- <div class="p-fluid p-formgrid p-grid pl-2 py-3">
                    <div class="p-col-4">
                      <span>Did you notify the Workforce</span>  <p-inputSwitch [(ngModel)]="isWorkforceNotified" styleClass="lcaWorkNotifySwitch" class="ml-4"></p-inputSwitch>
                    </div>
                  </div> -->
                  <div class="p-fluid p-formgrid p-grid pl-2 pt-2">
                    <div class="p-col-4 mt-4">
                      <span>Did you notify the Workforce</span> <p-inputSwitch [(ngModel)]="lca.isWorkforceNotified"
                        styleClass="lcaWorkNotifySwitch" class="ml-4"></p-inputSwitch>
                    </div>
                    <div class="p-col-4" *ngIf="lca.isWorkforceNotified">
                      <!-- <label for="workforceNotifiedDate">Workforce Notification Date</label>
                      <p-calendar name="workforceNotifiedDate" styleClass="fdnsQa-upload-calender"
                      [(ngModel)]="lca.workforceNotifiedDate" [minDate]="lcaApprovedDate" [maxDate]="maxDateValue" [showIcon]="true" dateFormat="mm-dd-yy"
                      ></p-calendar> -->
                      <label class="control-lbl mt-2 label-cls d-block required">Workforce Notification Date</label>
                      <mat-form-field class="matformfieldwidth1 w-100 date-field" appearance="outline">
                        <input [(ngModel)]="lca.workforceNotifiedDate" [max]="maxDateValue" [min]="lcaApprovedDate"
                          name="workforceNotifiedDateRef" matInput [matDatepicker]="workforceNotifiedDate"
                          #workforceNotifiedDateRef="ngModel" (click)="workforceNotifiedDate.open()" required>
                        <mat-datepicker-toggle matSuffix [for]="workforceNotifiedDate"></mat-datepicker-toggle>
                        <mat-datepicker #workforceNotifiedDate></mat-datepicker>
                      </mat-form-field>
                      <!-- <div class="invalid-message" *ngIf="workforceNotifiedDateRef.touched  && workforceNotifiedDateRef.errors?.required">
                            {{ getGlobalErrorMessages("REQUIRED") }}
                        </div> -->
                    </div>
    
                  </div>
                  <div class="p-fluid p-formgrid p-grid pl-2 pt-3" *ngIf="lca.isWorkforceNotified">
                    <div class="p-col-8">
                      <label for="tasktype" class="required">Upload proof of the 'Workforce Notification'</label>
                      <app-file-upload style="width: 100%;" [configurations]="workForceConfigurations"
                        (fileUploadSuccess)="getWorkForceUpolodedFiles()"></app-file-upload>
                    </div>
                  </div>
                  <div *ngIf="!lca.isWorkforceNotified">
                    <div class="p-fluid p-formgrid p-grid pl-2 pt-3">
                      <div class="p-col-8">
                        <p>Download template samples on how to Notify workspace</p>
                      </div>
                    </div>
                    <div class="row ml-2">
                      <!-- <div class="download-box p-0 m-0"> 
                      <app-file-download [fileName]="lca?.sampleFileOne?.substring(22)"
                     [Path]="envPath + lca?.sampleFileOne?.substring(22)" class="ml-3 pr-2"></app-file-download><span>Sample 1</span> 
                    </div>
                    <div class="ml-2 download-box p-0 m-0"> 
                      <app-file-download [fileName]="lca?.sampleFileTwo?.substring(22)"
                   [Path]="envPath + lca?.sampleFileTwo?.substring(22)" class="ml-3 pr-2"></app-file-download> <span>Sample 2</span>
                    </div> -->
                      <div *ngIf="lca && lca.sampleFileOne" class="mr-2 padding0">
                        <button pButton type="button" pTooltip="Download" (click)="downloadFile(lca.sampleFileOne)"
                          class="p-button-outlined"><i class="fa fa-download" aria-hidden="true"></i>Sample 1</button>
                      </div>
                      <div *ngIf="lca && lca.sampleFileTwo" class="mr-2 padding0">
                        <button pButton type="button" pTooltip="Download" (click)="downloadFile(lca.sampleFileTwo)"
                          class="p-button-outlined"><i class="fa fa-download" aria-hidden="true"></i>Sample 2</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dashed-line pt-3 mb-4"></div>
    
                <div class="formBox">
                  <div class="row mb-3">
                    <h6 class="labelText"><b> Other Documents Upload</b></h6>
                    <!-- <p class="mt-2"></p> -->
                  </div>
    
                  <div class="row">
                    <div class="col-12">
                      <app-file-upload style="width: 100%;" [configurations]="configurations"></app-file-upload>
                    </div>
                  </div>
    
                  <div class="row">
                    <div class="col-8">
                      <!-- <button type="button" class="back-button" matStepperPrevious>
                        Back
                      </button> -->
                      <button class="back-button pl-3 pr-3" matStepperPrevious><i class="fa fa-chevron-circle-left"
                          aria-hidden="true"></i>Back</button>
                    </div>
                    <div class="col-4 text-right">
                      <button type="button" class="btn btn-primary mt-0 mr-2" (click)="saveLcaWorkNotify()"
                        [disabled]="!lca.id">Save and Exit</button>
                    </div>
                  </div>
                </div>
              </mat-step>
            </mat-horizontal-stepper>
          </div>
        </mat-card>
      </div>
    </div>

    <div class="content-container pb-0">
      <mat-divider></mat-divider>
    </div>

    <div class="content-container pb-0" *ngIf="eFileLCa == 'lcaEFile'">
      <mat-card>
        <div class="row">
          <mat-horizontal-stepper #stepper labelPosition="bottom">
            <mat-step class="dashed-border">
              <ng-template matStepLabel>LCA</ng-template>
              <mat-accordion id="e-file-form">
                <div class="row">
                  <div class="col-md-12 p-0 preview-portion">
                    <!-- <button (click)="onClickPreview()">preview123</button> -->
                    <button class="preview" data-toggle="modal" data-target="#previewModal"
                      (click)="onClickPreview()"><mat-icon>keyboard_arrow_left</mat-icon><span>Preview</span></button>
                  </div>
                </div>
                <ng-container>
                  <div id="lcaFormParent">
                    <form [formGroup]="lcaForm" (ngSubmit)="onClickSaveLcaForm()">
                      <app-lca-details [lcaEFileApplication]="lcaForm.get('lcaEFileApplication')"
                        [editLcaEFileApplication]="editLcaData">
                      </app-lca-details>

                      <!-- Employer Information Start -->
                      <app-employer-information-lca [userInfoForm]="lcaForm.get('userInfoForm')"
                        [edituserInfoForm]="editLcaData ? editLcaData.employerInfo : ''">
                      </app-employer-information-lca>
                      <!-- Employer Information End -->
                      <!-- Employer Contact Information Start -->
                      <app-employer-contact-information
                        [employerContactInfoForm]="lcaForm.get('employerContactInfoForm')"
                        [employerContactInformation]="lcaForm.get('userInfoForm').value">
                      </app-employer-contact-information>
                      <!-- Employer Contact Information End -->
                      <!-- Attorney/Agent Information Start -->
                      <app-attorney-agent-information [attorneyInfoForm]="lcaForm.get('attorneyInfoForm')"
                        [companyInformation]="lcaForm.get('userInfoForm').value.companyName"
                        (change)="scrollToTop($event)">
                      </app-attorney-agent-information>
                      <!-- Attorney/Agent Information End -->
                      <!-- Employer Wage Information Start -->
                      <app-employment-wage-information [employmentWageForm]="lcaForm.get('employmentWageForm')"
                        [editLcaWageData]="editLcaData ? editLcaData : ''"
                        [socCode]="lcaForm.value.lcaEFileApplication.socCode">
                      </app-employment-wage-information>
                      <!-- Employer Wage Information End -->

                      <app-employer-labour-condition-statement [EmpLCS]="lcaForm.get('EmpLCS')"
                        [EmpLCSEdit]="editLcaData" (change)="scrollToTop($event)">
                      </app-employer-labour-condition-statement>

                      <app-employer-labour-condition [lcaAdlEmplStatH1BOnly]="lcaForm.get('lcaAdlEmplStatH1BOnly')"
                        [lcaAdlEmplStatH1BOnlyEdit]="editLcaData"></app-employer-labour-condition>
                      <app-public-discloser-info [publicDiscloseInfo]="lcaForm.get('publicDiscloseInfo')"
                        [editPublicDiscloseInfo]="editLcaData"></app-public-discloser-info>
                      <app-notice-of-obligations [noticeOfObligations]="lcaForm.get('noticeOfObligations')"
                        [employerInformation]="lcaForm.get('userInfoForm').value">
                        >
                      </app-notice-of-obligations>
                      <app-lca-preparer [lcaPreparer]="lcaForm.get('lcaPreparer')"
                        [editLcaDatalcaPreparer]="editLcaData ? editLcaData.lcaPreparer : ''">
                      </app-lca-preparer>
                      <div class="row">
                        <div class="form-group col-md-6 pl-0 pt-2">
                          <h5 class="labelText">Notes</h5>
                          <input type="text" class="im-input" name="comment" formControlName="comment"
                            placeholder="Enter Comment or Benificiary Name" maxlength="60" />
                          <p class="hintText d-block text-right">(Maximum 60 Characters)</p>
                        </div>
                      </div>

                      <div class="row efile-seperator">
                        <div class="col-md-12 p-0">
                          <hr class="dashed-border">
                        </div>
                      </div>


                      <div class="row" id="e-file-button">
                        <ul>
                          <li>
                            <button type="button" class="btn btn-primary button-cancel" (click)="handleCancel()">
                              CANCEL
                            </button>
                          </li>
                          <li class="second-li">
                            <lib-save-as-draft confirmModelKey="savedraftefilelca"
                              styleClass="btn btn-primary" [disabled]="isSaveAsDraftDisabled"
                              (onClickSaveAsDraft)="saveAsDraft($event)" [formToBeSaved]="lcaForm"></lib-save-as-draft>
                          </li>
                          <li class="mr-3">
                            <button type="submit" class="btn btn-primary" [disabled]="lcaForm.invalid">
                              SAVE
                            </button>
                          </li>
                          <li>
                            <button type="button" class="btn btn-primary button-next" matStepperNext>
                              NEXT
                            </button>
                          </li>
                        </ul>
                      </div>
                    </form>
                  </div>
                </ng-container>
              </mat-accordion>
            </mat-step>

            <mat-step>
              <ng-template matStepLabel>E- File</ng-template>
              <mat-divider></mat-divider>
              <br>
              <div class="p-4 ">
                <h6 class="col-md-12  labelText"><b>Ready to e-file</b></h6>
                <br>
                <span class="ml-3">
                  <b>Please check prerequisite for downloading e-file tracker application</b>
                  <button class="btn btn-primary ml-2 " data-toggle="modal" data-target="#myModal"
                    (click)="onClickPrerequisite()">Click here</button>
                </span>
                <br>
                <!-- <div class="row">
              <input style="display: none;"
                name="lcaEditID"
                id="lcaEditID"
                type="text"
                [(ngModel)]="lcaEditID"/> 
              </div> -->

                <br>

                <!-- <p class="col-md-6 "><b>Use The Following Information to Login the Tracker File Utility</b> </p>     -->

                <div class=" col-md-9 row border 1px">
                  <form [formGroup]="launchTracker" (ngSubmit)="onClickSavelaunchTracker()">
                    <br>
                    <div class="row col-md-12">
                      <p class="col-md-3 required ml-6">User Id (Flag System)</p>
                      <div class="form-group  col-md-9 ">
                        <input class="im-input" name="userName" formControlName="userName" type="text"
                          placeholder="Enter" />
                      </div>
                      <p class="col-md-3 required ml-6">Password (Flag System)</p>
                      <div class="form-group col-md-9">
                        <input class="im-input" name="password" formControlName="password" type="password"
                          placeholder="Enter" />
                      </div>
                      <p class="col-md-3 required ml-6">LCA ID</p>
                      <div class="form-group col-md-6">
                        <input class="im-input" name="lcaId" formControlName="lcaId" type="text" readonly
                          placeholder="Enter" />
                      </div>
                      <button type="button" (click)="copyToClipboard()"
                        class="btn btn-primary mt-0 float-right btn-add">{{CopyToClipboard}}</button>
                    </div>
                    <!-- <p class=" col-md-4 row mt-4 text-break">JHGI$YO</p>  -->
                    <!-- <span class=" col-md-4">
          <button type="button" class="btn btn-primary mr-5px float-right btn-add" >Copy To Clipboard</button>
           </span> -->
                    <br>
                    <span id="wrapper" class="row">
                      <button type="button" matStepperPrevious class="btn btn-primary  mt-0 mr-2 btn-add">back</button>
                      <button type="submit" class="btn btn-primary mt-0 mr-2 button-save"
                        [disabled]="launchTracker.invalid"> Save & Launch</button>
                      <!-- <button type="button"   (click) = "launch()" class="btn btn-primary mt-0 mr-2" [disabled]="launchTracker.invalid"> Launch </button> -->
                    </span>
                    <br>
                  </form>
                  <br>
                </div>
              </div>
            </mat-step>
          </mat-horizontal-stepper>
        </div>
      </mat-card>
    </div>


    <div>
      <!-- Modal -->
      <div class="modal fade" id="previewModal" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="preview">
                <h5>Preview</h5>
                <button type="button" #closebutton class="close" data-dismiss="modal">&times;</button>
              </div>
            </div>
            <div class="modal-body">
              <div id="previewEfile"></div>
            </div>
            <div class="modal-footer">
              <button mat-stroked-button color="primary" class="pull-right" (click)="onClose()">Close</button>
            </div>
          </div>
        </div>
      </div>
    
      <!-- Modal  showModalBox -->
    
      <div *ngIf="showModalBox" class="modal" id="myModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title">Download E-File Tracker Application </h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
              <div class="col-9 mt-1 pl-3">
                <label class="control-lbl required mt-2 label-cls">1. Please select <b>Yes</b> If you want to download
                  efile tracker application if already install you can select <b>No</b> </label>
                <div class="row pt-2">
                  <mat-radio-group aria-label="Select an option" [(ngModel)]="downloadedCond">
                    <mat-radio-button [value]=true>Yes</mat-radio-button>
                    <mat-radio-button [value]=false>No</mat-radio-button>
                  </mat-radio-group>
                </div>
                <label class="control-lbl required mt-2 label-cls">2. Please select installed OS in your machine</label>
                <div class="row pt-2">
                  <mat-radio-group aria-label="Select an option" [(ngModel)]="osInstalled">
                    <mat-radio-button [value]="'mac'">Mac</mat-radio-button>
                    <mat-radio-button [value]="'win'">window</mat-radio-button>
                    <!-- <mat-radio-button [value]="'lin'">linux</mat-radio-button> -->
                  </mat-radio-group>
                </div>
                <br>
                <div id="wrapper" class="row">
                  <button type="button" class="btn btn-primary  mt-0 ml-2 btn-add" data-dismiss="modal">close</button>
                  <button type="button" *ngIf="downloadedCond && osInstalled" class="btn btn-primary ml-2"
                    data-dismiss="modal" (click)="onClickDownload()"> Download</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- {{ lcaForm.value | json }}  -->
   